// packages/shared-versioning/src/version.ts
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "dev";
//# sourceMappingURL=version.js.map